var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLandingPageDesktopIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 21V19H10.5V17H4.5C3.95 17 3.47917 16.8042 3.0875 16.4125C2.69583 16.0208 2.5 15.55 2.5 15V5C2.5 4.45 2.69583 3.97917 3.0875 3.5875C3.47917 3.19583 3.95 3 4.5 3H20.5C21.05 3 21.5208 3.19583 21.9125 3.5875C22.3042 3.97917 22.5 4.45 22.5 5V15C22.5 15.55 22.3042 16.0208 21.9125 16.4125C21.5208 16.8042 21.05 17 20.5 17H14.5V19H16.5V21H8.5ZM4.5 15H20.5V5H4.5V15Z",
    fill: "#0094FB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingPageDesktopIcon);
export default __webpack_public_path__ + "static/media/landingPage_desktopIcon.d54725d16d33349a705a7b447271d3f4.svg";
export { ForwardRef as ReactComponent };